export enum IndigenousLands {
  IndigenousPeoplesLandsAcknowledgedByGov = 'IndigenousPeoplesLandsAcknowledgedByGov',
  IndigenousPeoplesLandsNotAcknowledgedByGov = 'IndigenousPeoplesLandsNotAcknowledgedByGov',
  LocalCommunityLandsAcknowledgedByGov = 'LocalCommunityLandsAcknowledgedByGov',
  LocalCommunityLandsNotAcknowledgedByGov = 'LocalCommunityLandsNotAcknowledgedByGov',
}
